import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import posthog from 'posthog-js'
import { login, logout, errorMessage } from '@/lib/api/client'
import { queryClient } from '@/lib/query-client'
import { isPostHogConfigured, posthogLogs } from '@/lib/posthog-logs'
import {
  identifySessionUser,
  resetSessionUser,
  sessionKey,
} from './use-session'

export function useLogin() {
  const navigate = useNavigate()
  return useMutation({
    mutationFn: login,
    onSuccess: async (session) => {
      identifySessionUser(session.user)
      if (isPostHogConfigured) {
        posthog.capture('login_succeeded', undefined, { send_instantly: true })
        posthogLogs.loginSucceeded()
      }
      queryClient.setQueryData(sessionKey, session)
      await navigate({ to: '/' })
    },
    onError: () => {
      if (isPostHogConfigured)
        posthog.capture('login_failed', undefined, { send_instantly: true })
    },
  })
}
export function useLogout() {
  const navigate = useNavigate()
  return useMutation({
    mutationFn: logout,
    onSuccess: async () => {
      if (isPostHogConfigured) {
        posthog.capture('logout_succeeded', undefined, { send_instantly: true })
        posthogLogs.logoutSucceeded()
      }
      resetSessionUser()
      await queryClient.cancelQueries()
      queryClient.clear()
      // Pending outbox and diagnostics deliberately survive logout.
      await navigate({ to: '/login' })
    },
    onError: (error) => {
      toast.error(errorMessage(error))
    },
  })
}
